export enum gender  {
  MAN = 'MAN',
  WOMAN = 'WOMAN'
}

export const feedbacks: Array<{event: string, gender: gender, name: string, quote: string}> = [
  {
    event: 'Hellfest',
    gender: gender.WOMAN,
    name: 'Laurence',
    quote: 'Le billet que je vendais a été mis en ligne et immédiatement vendu merci beaucoup.',
  },
  {
    event: 'Festival du Roi Arthur',
    gender: gender.MAN,
    name: 'JP',
    quote: 'Revente très rapide et à bon prix ! J\'ai apprécié la fiabilité du système.',
  },
  {
    event: 'Pete the Monkey',
    gender: gender.MAN,
    name: 'Martin',
    quote: 'Super service, merci beaucoup !',
  },
  {
    event: 'Festival Beauregard',
    gender: gender.WOMAN,
    name: 'Nana',
    quote: 'C\'était rapide et efficace, je n\'ai pas perdu d\'argent !',
  },
  {
    event: 'V and B Fest\'',
    gender: gender.WOMAN,
    name: 'Anne-Sophie',
    quote: 'Je n’y croyais absolument pas en me mettant sur la liste d’attente, alors que j’ai réussi à avoir ma place en moins de 24h ! C’est sécurisé et les prix ne s’envolent pas. Merci!',
  },
  {
    event: 'Cabaret Vert',
    gender: gender.WOMAN,
    name: 'Anne-Sophie',
    quote: 'Facile à comprendre, sécurisé (plusieurs niveaux de vérification) et la vente a été réalisée rapidement. Merci Reelax Tickets !',
  },
  {
    event: 'Hellfest',
    gender: gender.MAN,
    name: 'Patrick',
    quote: 'J\'étais sur liste d\'attente pour un billet pour l\'Hellfest, j\'ai été mis au courant à chaque étape et c\'était très important pour moi de pouvoir suivre l\'évolution. Au final, j\'ai eu un billet, merci pour tout.',
  },
  {
    event: 'POMME au Quai M',
    gender: gender.WOMAN,
    name: 'Lucie',
    quote: 'Rien de mieux pour détecter les escrocs : si un vendeur refuse de passer par Reelax Tickets, c’est mauvais signe',
  },
  {
    event: 'Fête du Bruit dans Landerneau',
    gender: gender.WOMAN,
    name: 'Ghislaine',
    quote: 'L\'équipe est très réactive! J\'ai pu mettre rapidement mes billets en vente',
  },
  {
    event: 'Fête du Bruit dans Saint-Nolff',
    gender: gender.WOMAN,
    name: 'Stéphanie',
    quote: 'À peine mis en vente, mes 2 billets étaient déjà vendus. Très efficace!',
  },
  {
    event: 'Festival de Poupet',
    gender: gender.MAN,
    name: 'Romain',
    quote: 'J\'ai loupé de peu la période de remboursement mais par chance j\'ai pu vendre mes billets sur votre site, merci !',
  },
  {
    event: 'Soprano - Foire aux vins d\'Alsace',
    gender: gender.MAN,
    name: 'Julien',
    quote: 'Parfait grâce aux alertes j\'ai pu acheter une place pour mon frère, juste à temps pour son anniversaire :)',
  },
  {
    event: 'Insane Festival',
    gender: gender.WOMAN,
    name: 'Claire',
    quote: 'Merci à l\'équipe très disponible. Ils ont pris le temps de m\'aider et j\'ai pu mettre mes billets en vente',
  },
  {
    event: 'Festival Bobital',
    gender: gender.MAN,
    name: 'Alex',
    quote: 'Au top, j\'ai pu acheter 2 billets en moins de 2 mins',
  },
  {
    event: 'Festival Bobital',
    gender: gender.WOMAN,
    name: 'Frédérique',
    quote: 'Site sérieux, j\'ai reçu mon argent 2 jours après avoir vendu mes billets',
  },
  {
    event: 'Festival du Roi Arthur',
    gender: gender.WOMAN,
    name: 'Elise',
    quote: 'J\'ai vendu mon billet pour le Roi Arthur en quelques clics, je recommande !',
  },
  {
    event: 'Garden au Château d\'Apigné',
    gender: gender.MAN,
    name: 'Hugo',
    quote: 'L\'événement était sold-out mais grâce aux alertes j\'ai pu obtenir un billet !',
  },
  {
    event: 'Festival No Logo Fraisans',
    gender: gender.MAN,
    name: 'Baptiste',
    quote: 'La vente de mon billet s\'est très bien passée !',
  },
  {
    event: 'Festival de Poupet',
    gender: gender.WOMAN,
    name: 'Coralie',
    quote: 'L\'événement a été reporté et Reelax m\'a remboursé. Merci !',
  },
  {
    event: 'Les Escales',
    gender: gender.WOMAN,
    name: 'Amélie',
    quote: 'L’événement était complet mais j’ai réussi à obtenir deux places grâce à vous ! Merci !',
  },
  {
    event: 'Insane Festival',
    gender: gender.MAN,
    name: 'Hadrien',
    quote: 'Super application. Évite les arnaques et rassure le vendeur et l\'acheteur. Rapide. Excellent !',
  },
  {
    event: 'Hellfest',
    gender: gender.WOMAN,
    name: 'Lucile',
    quote: 'Site très pratique à utiliser, performant et efficace !',
  },
];
